import { allowedPurposes, Purpose } from './purpose.enum'
import { Vendor } from './vendor.enum'

export const PURPOSE_IS_SET_ENTRY_ID = 0 as const

export type VendorWithPurposeIsSetMap = Map<
  Vendor | typeof PURPOSE_IS_SET_ENTRY_ID,
  boolean
> & { name?: string }
export type PurposeForVendorsMap = Map<Purpose, VendorWithPurposeIsSetMap>

export function defaultPurposeForVendorsMap(): PurposeForVendorsMap {
  const consentsStates: PurposeForVendorsMap = new Map()
  allowedPurposes.forEach((purposeId) => {
    const consentForPurposeMap: VendorWithPurposeIsSetMap = new Map()
    consentForPurposeMap.set(PURPOSE_IS_SET_ENTRY_ID, false)
    consentsStates.set(purposeId, consentForPurposeMap)
  })
  return consentsStates
}
